import type { ActiveFilter } from '@/shared/components';
import { usePermissions } from '@/features/auth';
import { useDealersByIds } from '@/features/dealers/hooks/useDealersByIds';
import { DOCUMENT_TYPE_LABELS } from '../utils/documentTypeLabels';
import { OWNER_FILTER_LABELS, STATUS_FILTER_LABELS } from '../utils/templateListOptions';
import type { useTemplateListFilters } from './useTemplateListFilters';

export function useTemplateFilterChips(list: ReturnType<typeof useTemplateListFilters>): ActiveFilter[] {
  const { filters, setFilter, setOwner } = list;
  const { hasPermission } = usePermissions();
  const dealers = useDealersByIds(
    filters.dealerId ? [filters.dealerId] : [],
    hasPermission({ resource: 'dealer', action: 'browse' }),
  );
  const dealerName = dealers.data?.find((dealer) => dealer.id === filters.dealerId)?.name ?? 'Selected dealer';

  const chips: (ActiveFilter | null)[] = [
    filters.documentType
      ? { key: 'type', label: `Type: ${DOCUMENT_TYPE_LABELS[filters.documentType]}`, onRemove: () => setFilter('documentType', undefined) }
      : null,
    filters.status
      ? { key: 'status', label: `Status: ${STATUS_FILTER_LABELS[filters.status]}`, onRemove: () => setFilter('status', undefined) }
      : null,
    filters.owner
      ? { key: 'owner', label: `Owner: ${OWNER_FILTER_LABELS[filters.owner]}`, onRemove: () => setOwner(undefined) }
      : null,
    filters.dealerId
      ? { key: 'dealer', label: `Dealer: ${dealerName}`, onRemove: () => setFilter('dealerId', undefined) }
      : null,
  ];
  return chips.filter((chip): chip is ActiveFilter => chip !== null);
}
